import { FormControl } from "@angular/forms";

export function passwordStrengthValidator(control: FormControl): {[key: string]: any} | null {
    const password = control.value;
    if (!password) return null;

    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password);
    const hasMinLength = password.length >= 12;

    const forbidden = ['monedero', 'sendero', 'gasmart', 'password', 'contraseña', '123456', 'qwerty', 'admin'];
    const hasForbidden = forbidden.some(word => password.toLowerCase().includes(word));

    const isValid = hasMinLength && hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar && !hasForbidden;
    return isValid ? null : { 'passwordStrength': true };
}
